module.exports = __webpack_public_path__ + "static/media/payment.9cd96e95.jpg";